import styled from "styled-components";
import { NakedInput } from "../../newCommon/ControlsCommon";
export const Input = styled(NakedInput) ``;
